fx.ns("desktop.common.screens", class BaseSplash extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;

		this._photoKey = shared.SplashContent.randomPhoto();
	}

    get title()
    {
        return this._title;
    }

    set title(val)
    {
        this._title = val;
		if (this.initialized)
			this._titleComponent.text = val;
    }

    get subtitle()
    {
        return this._subtitle;
    }

    set subtitle(val)
    {
        this._subtitle = val;

		if (this.initialized)
			this._textComponent.text = val;
    }

    get personBox()
    {
        return this._personBox;
    }

    get container()
    {
        return this._container;
    }

	create()
	{
		this._container = new fx.components.VBox("splash-content");

		this._personBox = new shared.component.Person(shared.SplashContent.photo(this._photoKey));

		this.container.addChild(this._personBox, { width : 220, height : 220 });

		this._titleComponent = new fx.components.Text({text : fx.text(this.title), className : "title"});
		this._textComponent = new fx.components.Text({text : fx.text(this.subtitle), className : "text"});

		this.container.addChild(this._titleComponent, { width : "100%", height : "auto" });
		this.container.addChild(this._textComponent, { width : "100%", height : "auto" });

		this.addChild(this.container, { width : "100%", height : "100%" });
	}

});

	